import type { Header } from "@tanstack/react-table";

import { icons } from "../common";

type SortIconProps<TData> = {
  className?: string;
  header: Header<TData, unknown>;
};

const { ArrowLongDownIcon, ArrowLongUpIcon, ArrowsUpDownIcon } = icons;

export const SortIcon = <TData,>({ className, header }: SortIconProps<TData>) => {
  const sortDirection = header.column.getIsSorted();
  if (sortDirection === "asc") {
    return <ArrowLongUpIcon className={className} />;
  }
  if (sortDirection === "desc") {
    return <ArrowLongDownIcon className={className} />;
  }

  return <ArrowsUpDownIcon className={className} />;
};
